import { useEffect } from 'react';
import { H2 } from '@comeon/ui';

import { Translations } from '~/components/payment/quick-deposit-beta/components-v2/types';
import { textKeysQDAmountScreen } from '~/components/payment/quick-deposit-beta/utils/constants';
import usePaymentTracking from '~/components/payment-beta/deposit/hooks/use-payment-tracking';

// Styled components
import { CloseButton, HeadWrapper, RoundedButtonSecondary, SubTitle } from './styles';
import { ContentWrapper } from '~/components/payment/quick-deposit-beta/components-v2/deposit-amount/styles';

type Props = {
	redirectToSow: () => void;
	handleClose: () => void;
	translation: Translations<typeof textKeysQDAmountScreen>;
};

const MewQDSOWScreen = ({ redirectToSow, handleClose, translation: t }: Props) => {
	const { trackQDEvent } = usePaymentTracking();

	// Track SOW popup appearance on component mount
	useEffect(() => {
		trackQDEvent({
			pixel_deposit_action: 'sow-popup-appeared'
		});
	}, [trackQDEvent]);

	const handleSOWRedirect = () => {
		// Track SOW redirect button click
		trackQDEvent({
			pixel_deposit_action: 'click-upload-sow-documents'
		});
		redirectToSow();
	};
	return (
		<>
			<HeadWrapper>
				<H2 data-at="main-title-deposit-limit">{t.SOW_PAGE_HEADER}</H2>
				<CloseButton className="at-icon-close page-head__close" onClick={handleClose} type="button" />
			</HeadWrapper>
			<ContentWrapper>
				<SubTitle dataAt="sub-title-deposit-limit">{`${t.QD_SOW_MESSAGE}`}</SubTitle>
				<RoundedButtonSecondary
					smallfont
					onClick={handleSOWRedirect}
					type="submit"
					className="u-relative button u-mb1"
					title="title"
					dataAt="new-mobile-quick-deposit-upload-documents"
				>
					{t.MOBILE_UPLOAD_DOCUMENTS}
				</RoundedButtonSecondary>
			</ContentWrapper>
		</>
	);
};

export default MewQDSOWScreen;
